export const MarkName = {
  DOCUMENT_START: import.meta.env.VITE_PERFORMANCE_DOCUMENT_START_MARK_NAME,
  APP_INIT_START: 'appInitStart',
  APP_READY: 'appReady',
  SPLASH_SCREEN_SHOWN: import.meta.env
    .VITE_PERFORMANCE_SPLASH_SCREEN_SHOWN_MARK_NAME,
  SPLASH_SCREEN_HIDDEN: 'splashScreenHidden',
} as const;

export const MeasureName = {
  TIME_TO_FIRST_PAINT: 'timeToFirstPaint',
  TIME_TO_LOAD: 'timeToLoad',
  TIME_TO_READY: 'timeToReady',
  TIME_TO_INTERACTIVE: 'timeToInteractive',
} as const;
